import React, { useState } from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [company, setCompany] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function onLogin(e) {
    e.preventDefault();

    if (loading) {
      return;
    }

    if (!email) {
      setErr("Email required");
      return;
    }

    if (email.indexOf("@") < 1) {
      setErr("invalid email");
      return;
    }

    if (!pass) {
      setErr("Password required");
      return;
    }

    if (pass.length < 4) {
      setErr("Longer password required");
      return;
    }

    if (!fname) {
      setErr("First name required");
      return;
    }
    if (!lname) {
      setErr("Last name required");
      return;
    }
    if (!company) {
      setErr("Company required");
      return;
    }

    setErr("");
    setLoading(true);

    const url = "https://apmgui.dripstat.com/rest/signup";
    const requestInit = {
      method: "POST",
      mode: "cors",
      redirect: "follow",
      credentials: "include",
      cache: "no-cache",
      body: new URLSearchParams(`email=${encodeURIComponent(email)}&pass=${encodeURIComponent(pass)}&company=${encodeURIComponent(company)}&fname=${encodeURIComponent(fname)}&lname=${encodeURIComponent(lname)}`),
    };
    const r = await fetch(new Request(url, requestInit));
    setLoading(false);

    if (r.status === 200) {
      window.location.href = "https://dashboard.dripstat.com";
      setLoading(false);
    } else {
      const errMsg = await r.json();
      setErr(errMsg);
    }
  }

  return (
    <>
      <Helmet lang="en" title="Signup">
        <meta name="viewport" content="width=1344" />
      </Helmet>
      <div id="authPage">
        <div className="container">
          <div className="columns is-desktop is-vcentered auth-wrapper">
            <div className="column has-text-centered">
              <Link to="/">
                <img src="/img/dripstat-logo-black.png" style={{ height: "58px" }} alt="" />
              </Link>
            </div>

            <div className="column">
              <form id="loginform" acceptCharset="UTF-8" name="loginform">
                <span className="columns">
                  <div className="column">
                    <label htmlFor="login-name">First Name</label>
                    <input className="form-control" type="text" name="username" required="required" value={fname} onChange={e => setFname(e.target.value)} />
                  </div>
                  <div className="column">
                    <label htmlFor="login-name">Last Name</label>
                    <input className="form-control" type="text" name="username" required="required" value={lname} onChange={e => setLname(e.target.value)} />
                  </div>
                </span>

                <p>
                  <label htmlFor="login-name">Company</label>
                  <input className="form-control" type="text" name="username" required="required" value={company} onChange={e => setCompany(e.target.value)} />
                </p>
                <p>
                  <label htmlFor="login-name">Work Email</label>
                  <input className="form-control" type="text" name="username" required="required" value={email} onChange={e => setEmail(e.target.value)} />
                </p>
                <p>
                  <label htmlFor="login-password">Password</label>
                  <input className="form-control" type="password" name="password" required="required" value={pass} onChange={e => setPass(e.target.value)} />
                </p>

                {err && (
                  <div className="alert alert-danger" id="loginError">
                    {err}
                  </div>
                )}
                <button className="btn lilac-btn btn-fluid btn-medium" id="loginBtn" type="submit" onClick={onLogin} disabled={loading}>
                  {loading ? "Signing up..." : "Sign up"}
                </button>
                <div className="form-forgot">
                  By signing up, you agree to the <Link to="/terms">Terms of Service</Link>.
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
